<template>
  <div>
    <div class="content-text" style="margin-top:30px;" v-if="showButtons">
      <div class="text">
        <div class="description">
          <p>Motivo de la Solicitud</p>
        </div>
        <div class="md:grid md:grid-cols-2 grid grid-cols-2 gap-4" style="margin-top:20px;">
          <div>
            <input type="button" class="chooseOptionButton w-full h-16" id="button_filter_accepted_request" 
              :value="valueButton1" style=""
              v-bind:style="{
                backgroundColor: reasonForTheRequest == 'normal' ? activeColorBackground : inactiveColorBackground, 
                color: reasonForTheRequest == 'normal' ? activeColorText : inactiveColorText,
                borderColor: reasonForTheRequest == 'normal' ? activeBorderColor : inactiveBorderColor
              }"
              v-on:click="changeButtonSelected('normal', true)"/>
          </div>
          <div>
            <input type="button" class="chooseOptionButton w-full h-16" id="button_filter_accepted_request" 
              :value="valueButton2" style=""
              v-bind:style="{
                backgroundColor: reasonForTheRequest == 'defuncion' ? activeColorBackground : inactiveColorBackground, 
                color: reasonForTheRequest == 'defuncion' ? activeColorText : inactiveColorText,
                borderColor: reasonForTheRequest == 'defuncion' ? activeBorderColor : inactiveBorderColor
              }"
              v-on:click="changeButtonSelected('defuncion', false)"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      reasonForTheRequest: "normal",
      activeColorBackground: '#198F99',
      inactiveColorBackground: '#FFF',
      activeColorText: '#FFF',
      inactiveColorText: '#198F99',
      activeBorderColor: "#198F99",
      inactiveBorderColor: "#198F99",
      data: {
        selectedReason: "",
        askAccessNip: true
      }
    }
  },
  props: {
    valueButton1: {
      type: String,
      default: ""
    },
    valueButton2: {
      type: String,
      default: ""
    },
    showButtons: {
      type: Boolean,
      default: true
    }
  },
  name: 'ChooseReasonButtonComponent',
  mounted() {
    this.changeButtonSelected(this.reasonForTheRequest, true);
  },
  methods: {
    changeButtonSelected(value, askNip) {
      this.reasonForTheRequest = value;
      this.data.selectedReason = value;
      this.data.askAccessNip = askNip;
      this.$emit("choose-reason-request", this.data);
    },
    clean() {
      this.reasonForTheRequest = "normal";
      this.data.selectedReason = "";
      this.data.askAccessNip = true;
      this.changeButtonSelected(this.reasonForTheRequest, true);
    }
  }
}
</script>